import {ScrollView, StyleSheet, Text, View} from "react-native";
import React from "react";
import StyleProvider from "./StyleProvider";
import {Button, Flex} from "antd";

interface FilterContextProps {
  getFilter: (name: string) => any;
  setFilter: (name: string, value: any) => void;
  resetFilters: () => void;
  isSubmitting?: boolean;
}

export interface CoreFiltersBaseProps {
  filter: FilterContextProps;
  isSmallScreen?: boolean;
  onSubmit: () => void;
}

export default function FilterContainer({
  children,
  onSubmit,
  onResetFilters,
  isSubmitting,
  isSmallScreen
}) {

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      e.preventDefault(); // prevent dropdown closing weirdness
      onSubmit();
    }
  };

  return (
    <StyleProvider>
      <View
        style={[
          styles.container,
          isSmallScreen && { borderColor: 'transparent', borderWidth: 0 },
        ]}
        onKeyDown={handleKeyDown}
      >
        {!isSmallScreen && (
          <Text style={{ fontSize: 18, fontWeight: '500' }}>Filters</Text>
        )}

        <ScrollView style={styles.filtersContainer}>
          {children}
        </ScrollView>

        <Flex justify='space-around' style={{ width: '100%' }} gap={8}>
          <Button
            block
            size='large'
            onClick={onResetFilters}
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            Reset
          </Button>

          <Button
            block
            onClick={onSubmit}
            size='large'
            variant='solid'
            color='primary'
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            Submit
          </Button>
        </Flex>
      </View>
    </StyleProvider>
  );
}

const styles = StyleSheet.create({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: '#fff',
    padding: 18,
    borderWidth: 1,
    borderColor:  '#CECECE',
    borderRadius: 6,
    flexShrink: 1,
    flex: 1,
    maxWidth: 400
  },
  filtersContainer: {
    flex: 1,
    minWidth: 248
  }
});
